import { freddyTheme } from '@coolblue-development/freddy';
export const getResponsiveContainer = ({ maxThumbnailItems, thumbnailCount, hasButtons, }) => {
    const queryTag = hasButtons ? 'button' : 'div';
    const resetStyles = {
        [hasButtons ? '&' : 'label']: {
            borderStyle: 'solid',
            '&:before': {
                display: 'none',
            },
            '> div': {
                display: 'flex',
            },
        },
    };
    const counterStyles = {
        justifyContent: 'center',
        alignItems: 'center',
        background: freddyTheme.color.background.backdropBase,
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        color: freddyTheme.color.font.inverseBase,
        fontWeight: freddyTheme.typography.h2.fontWeight,
        fontSize: freddyTheme.typography.fontSize['3xl'],
        content: '"+"counter(thumbnail-count)',
        left: 0,
        top: 0,
        zIndex: 1,
    };
    return {
        counterReset: `thumbnail-count ${thumbnailCount}`,
        gap: freddyTheme.spacing[200],
        ...(typeof maxThumbnailItems === 'number' && {
            [`> ${queryTag}:nth-of-type(-n+${maxThumbnailItems})`]: {
                display: 'initial',
                counterIncrement: 'thumbnail-count -1',
                ...resetStyles,
            },
            [`> ${queryTag}:nth-of-type(n+${maxThumbnailItems + 1})`]: {
                display: 'none',
            },
            [`> ${queryTag}:nth-of-type(${maxThumbnailItems})`]: {
                [hasButtons ? '&' : 'label']: {
                    borderStyle: 'none',
                    '&:before': counterStyles,
                    '> div': {
                        display: 'none',
                    },
                },
            },
        }),
        ...(typeof maxThumbnailItems === 'object' && {
            [`> ${queryTag}:nth-of-type(-n+${maxThumbnailItems['xs']})`]: {
                display: 'initial',
                counterIncrement: 'thumbnail-count -1',
                ...resetStyles,
            },
            [`> ${queryTag}:nth-of-type(n+${maxThumbnailItems['xs'] + 1})`]: {
                display: 'none',
            },
            ...(maxThumbnailItems['xs'] &&
                thumbnailCount - 1 > maxThumbnailItems['xs'] && {
                [`> ${queryTag}:nth-of-type(${maxThumbnailItems['xs']})`]: {
                    [hasButtons ? '&' : 'label']: {
                        borderStyle: 'none',
                        '&:before': counterStyles,
                        '> div': {
                            display: 'none',
                        },
                    },
                },
            }),
            ...['sm', 'md', 'lg', 'xl'].reduce((styles, breakpoint) => {
                return {
                    ...styles,
                    ...(maxThumbnailItems[breakpoint] &&
                        maxThumbnailItems[breakpoint] <= thumbnailCount - 1 && {
                        [freddyTheme.breakpoint.minWidth(breakpoint)]: {
                            [`> ${queryTag}:nth-of-type(-n+${maxThumbnailItems[breakpoint]})`]: {
                                display: 'initial',
                                counterIncrement: 'thumbnail-count -1',
                                ...resetStyles,
                            },
                            [`> ${queryTag}:nth-of-type(n+${maxThumbnailItems[breakpoint] + 1})`]: {
                                display: 'none',
                            },
                            ...(thumbnailCount - 1 > maxThumbnailItems[breakpoint] && {
                                [`> ${queryTag}:nth-of-type(${maxThumbnailItems[breakpoint]})`]: {
                                    [hasButtons ? '&' : 'label']: {
                                        borderStyle: 'none',
                                        '&:before': counterStyles,
                                        '> div': {
                                            display: 'none',
                                        },
                                    },
                                },
                            }),
                        },
                    }),
                };
            }, {}),
        }),
    };
};
//# sourceMappingURL=ThumbnailBar.styles.js.map